export enum RiskProfilerAnswerScoreTypes {
  No_Risk = 0,
  Low = 1,
  Moderate = 2,
  Medium = 3,
  High = 4,
  Significant = 5
}
